import {inject, Injectable} from '@angular/core';
import { RecordsTableService } from '../../../services/records-table.service';
import {UserPreferencesService} from "../../../services/user-preferences.service";
import {DateFromToValue, FiltersValues, RecordTableColumnParams} from "../../../types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class RecordsTableFiltersService {
  private recordsTableService: RecordsTableService = inject(RecordsTableService);
  private userPreferencesService: UserPreferencesService = inject(UserPreferencesService);

  public getFiltersFromUserPreferences(): FiltersValues | null {
    return this.userPreferencesService.getUserPreferences()?.filtersValue || null;
  }

  public createFiltersValues(filtersParams: Array<RecordTableColumnParams>): FiltersValues {
    const filtersValues: FiltersValues = {};
    const filtersValuesFromUserPreferences: FiltersValues | null = this.getFiltersFromUserPreferences();

    for (let filterParam of filtersParams) {
      const defaultValueFromBE = filtersValuesFromUserPreferences?.[filterParam.key] || filterParam.defaultFilterValue;
      if (!defaultValueFromBE) {
        filtersValues[filterParam.key] = this.recordsTableService.getDefaultValueAccordingToType(filterParam.type);
        continue;
      }

      if (filterParam.type === 'DATE') {
        const fromDate: string = (defaultValueFromBE as DateFromToValue).from;
        const toDate: string = (defaultValueFromBE as DateFromToValue).to;
        filtersValues[`${filterParam.key}From`] = fromDate;
        filtersValues[`${filterParam.key}To`] = toDate;
        continue;
      }

      if (filterParam.type === 'NUMERIC') {
        const fromDate: string = (defaultValueFromBE as DateFromToValue).from;
        const toDate: string = (defaultValueFromBE as DateFromToValue).to;
        filtersValues[`${filterParam.key}From`] = fromDate;
        filtersValues[`${filterParam.key}To`] = toDate;
        continue;
      }

      filtersValues[filterParam.key] = defaultValueFromBE;
    }

    return filtersValues;
  }
}
